export default __webpack_public_path__ + "static/media/Add_square.5272e40c.svg";